/** Proporção da logo padrão do sidebar (1224×204). */
export const BRAND_LOGO_ASPECT_RATIO = 6

/** Dimensões recomendadas para upload (2× do tamanho exibido no menu). */
export const BRAND_LOGO_RECOMMENDED = {
  width: 720,
  height: 120,
} as const

/** Tamanho exibido no sidebar expandido (max-w-[180px], h-6). */
export const BRAND_LOGO_SIDEBAR_DISPLAY = {
  width: 180,
  height: 30,
} as const

/** Tamanho exibido na tela de login (.login-logo width 220px). */
export const BRAND_LOGO_LOGIN_DISPLAY = {
  width: 220,
  height: 37,
} as const

export const BRAND_LOGO_ACCEPT = 'image/png,image/jpeg,image/webp,image/svg+xml'
export const BRAND_LOGO_MAX_BYTES = 5 * 1024 * 1024

export type BrandLogoVariant = 'dark' | 'light' | 'fallback'

export const BRAND_LOGO_VARIANT_FIELD: Record<
  BrandLogoVariant,
  'logoUrlDark' | 'logoUrlLight' | 'logoUrl'
> = {
  dark: 'logoUrlDark',
  light: 'logoUrlLight',
  fallback: 'logoUrl',
}
